// TODO: Remove all debug logs before production deployment
// Use this utility to conditionally log only in development

interface DebugLogger {
  auth: (message: string, ...args: unknown[]) => void
  error: (message: string, ...args: unknown[]) => void
  info: (message: string, ...args: unknown[]) => void
}

const isDevelopment = import.meta.env.DEV

export const debug: DebugLogger = {
  auth: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.log(`[AUTH] ${message}`, ...args)
    }
  },

  error: (message: string, ...args: unknown[]) => {
    // if (isDevelopment) {
    console.error(`[ERROR] ${message}`, ...args)
    // }
  },

  info: (message: string, ...args: unknown[]) => {
    if (isDevelopment) {
      console.info(`[INFO] ${message}`, ...args)
    }
  },
}

// TODO: Before production deployment:
// 1. Remove all debug.* calls
// 2. Keep only essential error logging
// 3. Consider using proper logging service (e.g., Firebase Analytics events)
